/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRegisterDto
 */
export interface GetRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof GetRegisterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegisterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRegisterDto
     */
    pattern?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegisterDto
     */
    withUser?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetRegisterDto
     */
    mode?: GetRegisterDtoModeEnum | null;
}


/**
 * @export
 */
export const GetRegisterDtoModeEnum = {
    OK: 'OK',
    KMP: 'KMP',
    BR: 'BR',
    K75: 'K75',
    K43: 'K43',
    KS: 'KS',
    KU: 'KU',
    LBR: 'LBR'
} as const;
export type GetRegisterDtoModeEnum = typeof GetRegisterDtoModeEnum[keyof typeof GetRegisterDtoModeEnum];


/**
 * Check if a given object implements the GetRegisterDto interface.
 */
export function instanceOfGetRegisterDto(value: object): value is GetRegisterDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetRegisterDtoFromJSON(json: any): GetRegisterDto {
    return GetRegisterDtoFromJSONTyped(json, false);
}

export function GetRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRegisterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'withUser': json['withUser'] == null ? undefined : json['withUser'],
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function GetRegisterDtoToJSON(value?: GetRegisterDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'pattern': value['pattern'],
        'withUser': value['withUser'],
        'mode': value['mode'],
    };
}

